
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { WebhookLog } from "@/types/notifications";

export const useWebhookLogs = (notificationId: string | undefined) => {
  return useQuery({
    queryKey: ["webhook-logs", notificationId],
    queryFn: async () => {
      if (!notificationId) return [];

      const { data, error } = await supabase
        .from("notification_webhook_logs")
        .select("*")
        .eq("notification_id", notificationId)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Error fetching webhook logs:", error);
        throw error;
      }
      
      return data as WebhookLog[];
    },
    enabled: !!notificationId
  });
};
